import createIcon from '../../createIcon';

/**
 * @component @name RestartAlt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgNS41MzUxNlYyLjUzNTE2TDggNi41MzUxNkwxMiAxMC41MzUyVjcuNTM1MTZDMTUuMzEgNy41MzUxNiAxOCAxMC4yMjUyIDE4IDEzLjUzNTJDMTggMTYuNTA1MiAxNS44MyAxOC45NjUyIDEzIDE5LjQ0NTJWMjEuNDY1MkMxNi45NSAyMC45NzUyIDIwIDE3LjYxNTIgMjAgMTMuNTM1MkMyMCA5LjExNTE2IDE2LjQyIDUuNTM1MTYgMTIgNS41MzUxNloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik02IDEzLjUzNTJDNiAxMS44ODUyIDYuNjcgMTAuMzg1MiA3Ljc2IDkuMjk1MTZMNi4zNCA3Ljg3NTE2QzQuOSA5LjMyNTE2IDQgMTEuMzI1MiA0IDEzLjUzNTJDNCAxNy42MTUyIDcuMDUgMjAuOTc1MiAxMSAyMS40NjUyVjE5LjQ0NTJDOC4xNyAxOC45NjUyIDYgMTYuNTA1MiA2IDEzLjUzNTJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RestartAlt = createIcon('RestartAlt', [
  [
    'path',
    {
      d: 'M12 5.53516V2.53516L8 6.53516L12 10.5352V7.53516C15.31 7.53516 18 10.2252 18 13.5352C18 16.5052 15.83 18.9652 13 19.4452V21.4652C16.95 20.9752 20 17.6152 20 13.5352C20 9.11516 16.42 5.53516 12 5.53516Z',
      key: 'e85mnw',
    },
  ],
  [
    'path',
    {
      d: 'M6 13.5352C6 11.8852 6.67 10.3852 7.76 9.29516L6.34 7.87516C4.9 9.32516 4 11.3252 4 13.5352C4 17.6152 7.05 20.9752 11 21.4652V19.4452C8.17 18.9652 6 16.5052 6 13.5352Z',
      key: '1qd27s',
    },
  ],
]);

export default RestartAlt;
